<template>
  <div>
    <div class="box news-box">
      <div class="sub-nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>机构职能</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="new-wrapper">
        <div class="left-box fl">
          <div @click="tab(item,index)" :class="activeIndex == index ? 'left-box-title-noSelected active' : 'left-box-title-noSelected'" v-for="(item,index) in list" :key="index">
            <div class="left-box-title-main">
              <!-- <img src="../../assets/images/s.png" alt /> -->
              <span :title="item.name">{{item.name}}</span>
            </div>
            <img  class="bj" src="../../assets/images/right.png" alt />
          </div>
        </div>
        <div class="right-box fn-box fr">
          <h2>职能简介</h2>
          <div class="info" v-if="list[activeIndex].briefIntroduction">
            {{list[activeIndex].briefIntroduction}}
          </div>
          <div v-else class="info">
              亲，暂无内容哦
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import { getOfficeList, getOfficeById} from "../../api/index";
export default {
  name: "",
  data() {
    return {
      fullHeight: document.documentElement.clientHeight,
      list: [],
      activeIndex:0,
      detail:{}
    };
  },
  filters: {
			//将时间戳过滤为正常日期格式
			dateFormat: function (data) {
			  var date = new Date(data.replace(/-/g,"/")).Format("yyyy-MM-dd");
			  return date;
			}
	},
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getOfficeList({}).then(res => {
        this.list = res.data;
      });
    },
    tab(item,index){
        this.activeIndex = index;
        // this.getById(item.id)
    },
    getById(id){
        getOfficeById({
            id:id
        }).then(res => {
            this.detail = res.data;
        });
    },
  }
};
</script>

<style lang="" >
</style>


// WEBPACK FOOTER //
// src/views/institutionalFunction/index.vue